import { useCallback, useState } from "react";
import { Routes, Route, Link } from "react-router";
import { createSignalRContext } from "react-signalr";
import { HttpTransportType, LogLevel } from "@microsoft/signalr";

import { FaTasks } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { MdAssignmentReturn } from "react-icons/md";

import OrderBoard from "./orderboard/OrderBoard";

import styles from "./navbar.module.css";
import Help from "../main/Help";
import CompanyMain from './paymentCompanies/Main';
import Returns from './returns/Returns';

export const SignalRContext = createSignalRContext();

export default function NavBar({ pick, jwt }) {
  const [isOpen, setIsOpen] = useState(false);
  const [signalRVersion, setSignalRVersion] = useState(0);

  const handleSignalRConnected = useCallback(() => {
    setSignalRVersion((version) => version + 1);
  }, []);

  const menuItems = [
    {
      to: "/work/orderboard",
      icon: <FaTasks className={styles.navIcon} />,
      label: "Заказы",
    },
    {
      to: "/work/waiting",
      icon: <MdPayment className={styles.navIcon} />,
      label: "Оплата",
    },
    {
      to: "/work/returns",
      icon: <MdAssignmentReturn className={styles.navIcon} />,
      label: "Возвраты",
    },
  ];

  return (
    <SignalRContext.Provider
      skipNegotiation={true}
      logger={LogLevel.None}
      transport={HttpTransportType.WebSockets}
      accessTokenFactory={async () => jwt}
      url="/api/orders/hub"
      automaticReconnect={[0, 2000, 5000, 10000, 30000]}
      onOpen={handleSignalRConnected}
      onReconnect={handleSignalRConnected}
    >
      <header className={styles.navbar}>
        <div className={styles.inner}>
          <Link to="/" className={styles.logo}>
            SIVIL LAB
            <span className={styles.logoSub}>Пункт выдачи</span>
          </Link>

          <nav className={styles.desktopNav}>
            {menuItems.map((item) => (
              <Link key={item.label} to={item.to} className={styles.desktopLink}>
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}

            <Link to="/help" className={styles.helpLink}>
              Возникли трудности?
            </Link>
          </nav>

          <button
            className={styles.burger}
            onClick={() => setIsOpen(true)}
            aria-label="Открыть меню"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <div
        className={`${styles.overlay} ${isOpen ? styles.overlayActive : ""}`}
        onClick={() => setIsOpen(false)}
      />

      <aside className={`${styles.drawer} ${isOpen ? styles.drawerActive : ""}`}>
        <div className={styles.drawerHeader}>
          <span>Меню</span>
          <button onClick={() => setIsOpen(false)} aria-label="Закрыть меню">
            ✕
          </button>
        </div>

        <div className={styles.drawerNav}>
          {menuItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className={styles.drawerLink}
              onClick={() => setIsOpen(false)}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          ))}

          <Link
            to="/help"
            className={styles.drawerHelpLink}
            onClick={() => setIsOpen(false)}
          >
            Возникли трудности?
          </Link>
        </div>
      </aside>

      <main className={styles.page}>
        <Routes>
          <Route
            path="/*"
            element={
              <OrderBoard
                jwt={jwt}
                pick={pick}
                signalRVersion={signalRVersion}
              />
            }
          />
          <Route path="/waiting" element={<CompanyMain jwt={jwt}/>} />
          <Route path="/returns" element={<Returns jwt={jwt} />} />
          <Route path="/help" element={<Help/>} />
        </Routes>
      </main>
    </SignalRContext.Provider>
  );
}
